import React, { Component } from 'react';
import './OptinlogsTable.css';
import '../../globalcss.css';
import { Container, Title } from './OptinTable.styled';
import { Box } from 'grommet';
import { Row, Col, Drawer } from 'antd';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actioncreators from '../../redux/action';
import { authUserHelper } from '../../redux/helpers/index';
import _union from 'underscore-es/union';
import * as moment from 'moment';
import { contactsWithGroups } from '../../redux/services/contact';
import {
  getOrganizationTopics,
  fetchOrgGroups,
} from '../../redux/services/groups';
import * as services from '../../redux/services';
import MaterialTable, { MTableCell } from 'material-table';
import {
  buildEventRows,
  isLegacy,
  eventLabel,
  sourceLabel,
  actorLabel,
  getChannelChanges,
  getDisableTextingChange,
  disableTextingLabel,
  getLegacyTopics,
  resolveTopicName,
} from './historyFormat';

const formatLogDate = (createdOn, format) =>
  typeof createdOn === 'number'
    ? moment.unix(createdOn).format(format)
    : 'Not recorded';

class OptinlogsTable extends Component {
  constructor(props) {
    super(props);
    moment.locale('en');
    this.state = {
      memberList: [],
      logs: [],
      log: {},
      savedByUser: null,
      selectedUser: {},
      tagLookup: {},
      pageSize: parseInt(localStorage.getItem('pageSize'), 10) || 10,
    };
  }

  componentDidMount() {
    authUserHelper(this.props);

    if (
      this.props.organization.selected &&
      this.props.organization.selected.id
    ) {
      this.getMembers(this.props.organization.selected.id);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !Object.is(
        prevProps.organization.selected,
        this.props.organization.selected
      )
    ) {
      this.getMembers(this.props.organization.selected.id);
    }
  }

  showpersonaltestDrawer = data => {
    this.getLogsForMember(data);
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  showdetailsDrawer = async row => {
    const log = row.log;
    this.setState({
      detailsDrawer: true,
      log,
      savedByUser: null,
    });
    if (log.savedBy) {
      // getUser returns false on failure; the drawer then shows the raw id
      const userInfo = await services.getUser(log.savedBy);
      if (userInfo && !userInfo.error && this.state.log === log) {
        this.setState({ savedByUser: userInfo });
      }
    }
  };
  ondetailsDrawerClose = () => {
    this.setState({
      detailsDrawer: false,
    });
  };

  getLogsForMember = async data => {
    this.setState({ logs: [], selectedUser: data });
    this.props.actions.fullloader(true, 'Loading Logs...');
    const logsRes = await services.getOptinLogs(data.noteRouterId);
    this.props.actions.fullloader(false);
    if (logsRes.error) {
      this.props.actions.toast(
        'error',
        logsRes.status === 403
          ? 'You do not have access to the logs for this contact.'
          : 'Error loading logs for this contact.'
      );
      return;
    }
    if (logsRes.length < 1) {
      this.props.actions.toast('info', 'No Logs Found For This Member.');
      return;
    }
    this.setState({ logs: buildEventRows(logsRes) });
  };

  getMembers = async orgId => {
    if (orgId) {
      let taglookup = {};
      this.props.actions.fullloader(true, 'Loading Members...');
      const tags = await fetchOrgGroups(orgId);
      const topics = await getOrganizationTopics(orgId);
      if (!tags.error && !topics.error) {
        if (tags.length < 1 && topics.length < 1) {
          this.setState({ tagLookup: {} });
          this.props.actions.fullloader(false);
          return;
        }
        for (let tag of tags) {
          taglookup[tag.id] = tag.name;
        }
        for (let topic of topics) {
          taglookup[topic.id] = topic.name;
        }
        this.setState({ tagLookup: taglookup });
      }

      const memberOptions = {
        orgId: orgId,
      };
      const members = await contactsWithGroups(memberOptions);
      if (!members.error) {
        if (members.length < 1) {
          this.props.actions.fullloader(false);
          return;
        }
        let memberList = await members.map(member => {
          let tempTags = _union(
            member.identifiers,
            member.emailTags,
            member.textTags
          );
          let memberTags = [];
          for (let tag of tempTags) {
            if (taglookup[tag]) {
              memberTags.push(tag);
            }
          }
          member.tags = memberTags;
          return member;
        });
        this.props.actions.fullloader(false);
        this.setState({
          memberList: memberList,
        });
      } else {
        this.props.actions.fullloader(false);
      }
    }
  };

  renderDetail = (label, content, contentClass = 'detailscontent') => (
    <Row>
      <p className="detailspart">
        <span className="detailslabel">{label} : </span>
        <span className={contentClass}>{content}</span>
      </p>
    </Row>
  );

  renderTopicList = ids =>
    ids.length ? (
      ids.map(id => (
        <p className="chipone" key={id}>
          {resolveTopicName(id, this.state.tagLookup)}
        </p>
      ))
    ) : (
      <span className="detailscontent">None</span>
    );

  renderTopicChanges = log => {
    if (isLegacy(log)) {
      return (
        <div>
          {this.renderDetail('Before', 'Not recorded')}
          {getLegacyTopics(log).map(({ key, label, topics }) => (
            <Row key={key}>
              <Col span={24} className="tagsec">
                <span className="detailslabel taghead">
                  Recorded topics ({label})
                </span>
                {topics ? (
                  this.renderTopicList(topics)
                ) : (
                  <span className="detailscontent">Not recorded</span>
                )}
              </Col>
            </Row>
          ))}
        </div>
      );
    }

    const textingChange = getDisableTextingChange(log);
    return (
      <div>
        {textingChange?.changed &&
          this.renderDetail('Texting', disableTextingLabel(textingChange))}
        {getChannelChanges(log).map(
          ({ key, label, recorded, added, removed, after }) => (
            <Row key={key}>
              <Col span={24} className="tagsec">
                <span className="detailslabel taghead">{label}</span>
                {recorded ? (
                  <div>
                    <p className="detailspart m0">
                      <span className="detailslabel">Added : </span>
                    </p>
                    {this.renderTopicList(added)}
                    <p className="detailspart m0">
                      <span className="detailslabel">Removed : </span>
                    </p>
                    {this.renderTopicList(removed)}
                    <p className="detailspart m0">
                      <span className="detailslabel">Subscriptions : </span>
                    </p>
                    {this.renderTopicList(after)}
                  </div>
                ) : (
                  <span className="detailscontent">Not recorded</span>
                )}
              </Col>
            </Row>
          )
        )}
      </div>
    );
  };

  render() {
    return (
      <Container>
        <Title>Preference Logs</Title>
        <Box className="noterouter_managetable btnseparation">
          <MaterialTable
            components={{
              Cell: props => <MTableCell {...props} />,
            }}
            columns={[
              {
                title: 'First Name',
                field: 'firstName',
                defaultSort: 'asc',
              },
              { title: 'Last Name', field: 'lastName' },
              {
                title: 'Organization',
                field: '',
                render: () => {
                  return (
                    <p>{this.props.organization.selected.organizationName}</p>
                  );
                },
              },
              {
                title: 'Tags Assigned',
                field: 'tags',
                padding: 'dense',
                lookup: this.state.tagLookup,
                customFilterAndSearch: (text, rowData, column) => {
                  let name = rowData.firstName + ' ' + rowData.lastName;
                  let filter = Object.keys(column.lookup).filter(lookup => {
                    return column.lookup[lookup]
                      .toLowerCase()
                      .includes(text.toLowerCase());
                  });
                  let intersection = rowData.tags.filter(x =>
                    filter.includes(x)
                  );
                  return (
                    (name && name.toLowerCase().includes(text.toLowerCase())) ||
                    (rowData.lastName &&
                      rowData.lastName
                        .toLowerCase()
                        .includes(text.toLowerCase())) ||
                    (this.props.organization.selected &&
                      this.props.organization.selected.organizationName &&
                      this.props.organization.selected.organizationName
                        .toLowerCase()
                        .includes(text.toLowerCase())) ||
                    intersection.length > 0
                  );
                },
                render: rowData => {
                  return rowData.tags.map((tag, index) => {
                    return (
                      <p className="chipone" key={index}>
                        {this.state.tagLookup[tag]}
                      </p>
                    );
                  });
                },
              },
            ]}
            data={this.state.memberList}
            className="Manage_materialtable"
            actions={[]}
            options={{
              showTitle: false,
              padding: 'dense',
              search: true,
              pageSize: this.state.pageSize,
              headerStyle: {
                fontWeight: 'bold',
              },
              pageSizeOptions: [10, 20, 50],
            }}
            onRowClick={(e, data) => this.showpersonaltestDrawer(data)}
            onChangeRowsPerPage={e => {
              localStorage.setItem('pageSize', e);
              this.setState({ pageSize: e });
            }}
          />
          {this.state.selectedUser && (
            <Drawer
              title="Event List"
              width={800}
              onClose={this.onClose}
              visible={this.state.visible}
              style={{
                overflow: 'auto',
                paddingLeft: '0',
                paddingRight: '0',
              }}
            >
              <div className="ManagePortalUserscomp ant-drawerpart">
                <Box overflow="auto">
                  <div className="middlePart">
                    <Box className="noterouter_managetable btnseparation">
                      <MaterialTable
                        components={{
                          Cell: props => <MTableCell {...props} />,
                        }}
                        columns={[
                          {
                            title: 'Date/Time',
                            field: 'log.createdOn',
                            // keep the _id order from buildEventRows; sort by _id on click
                            customSort: (a, b) =>
                              String(a.log._id).localeCompare(
                                String(b.log._id)
                              ),
                            render: rowData => (
                              <p>
                                {formatLogDate(
                                  rowData.log.createdOn,
                                  'YYYY-MM-DD hh:mm A'
                                )}
                              </p>
                            ),
                          },
                          { title: 'Event', field: 'event' },
                          { title: 'Source', field: 'source' },
                          { title: 'Actor', field: 'actor' },
                          { title: 'Changes', field: 'summary' },
                        ]}
                        data={this.state.logs}
                        className="Manage_materialtable"
                        title=""
                        actions={[]}
                        options={{
                          pageSize: this.state.pageSize,
                          pageSizeOptions: [10, 20, 50],
                        }}
                        onChangeRowsPerPage={e => {
                          localStorage.setItem('pageSize', e);
                          this.setState({ pageSize: e });
                        }}
                        onRowClick={(e, data) => this.showdetailsDrawer(data)}
                      />

                      <Drawer
                        title="Event Details"
                        className="detailsSection"
                        width={400}
                        onClose={this.ondetailsDrawerClose}
                        visible={this.state.detailsDrawer}
                      >
                        {this.state.detailsDrawer && this.state.log && (
                          <div>
                            {this.renderDetail(
                              'Date',
                              formatLogDate(
                                this.state.log.createdOn,
                                'MM-DD-YYYY hh:mm A'
                              )
                            )}
                            {this.renderDetail(
                              'Name',
                              `${this.state.selectedUser?.firstName || ''} ${
                                this.state.selectedUser?.lastName || ''
                              }`
                            )}
                            {this.renderDetail(
                              'Email Id',
                              this.state.selectedUser?.email
                            )}
                            {this.renderDetail(
                              'Phone Number',
                              this.state.selectedUser?.phoneNumber
                            )}
                            {this.renderDetail(
                              'Event',
                              eventLabel(this.state.log)
                            )}
                            {this.renderDetail(
                              'Status',
                              this.state.log.status,
                              'detailscontent statuschip'
                            )}
                            {this.renderDetail(
                              'Source',
                              sourceLabel(this.state.log)
                            )}
                            {this.renderDetail(
                              'Actor',
                              actorLabel(this.state.log)
                            )}
                            {this.renderDetail(
                              'Message',
                              this.state.log.message
                            )}
                            {this.state.log.savedBy &&
                              this.renderDetail(
                                'Saved By',
                                this.state.savedByUser
                                  ? `${this.state.savedByUser.firstName} ${this.state.savedByUser.lastName}`
                                  : this.state.log.savedBy
                              )}
                            {this.renderTopicChanges(this.state.log)}
                          </div>
                        )}
                      </Drawer>
                    </Box>
                  </div>
                </Box>
              </div>
            </Drawer>
          )}
        </Box>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return state;
};
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actioncreators, dispatch),
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OptinlogsTable)
);
